import React from 'react';
import {View} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

type SafeAreaPaddingProps = {
  top?: boolean;
  bottom?: boolean;
};

function SafeAreaPadding({top, bottom}: SafeAreaPaddingProps) {
  const insets = useSafeAreaInsets();
  return (
    <View
      style={[
        top && {paddingTop: insets.top},
        bottom && {paddingBottom: insets.bottom},
      ]}
    />
  );
}

export default SafeAreaPadding;
